import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SourcingProvider } from './contexts/SourcingContext';
import SourcingEventLayout from './components/sourcing/SourcingEventLayout';
import SupplierDiscovery from './components/sourcing/SupplierDiscovery';
import ReviewScreen from './components/sourcing/ReviewScreen';
import EventDashboard from './components/sourcing/EventDashboard';
export function AppRouter() {
  return <BrowserRouter data-id="element-4">
      <SourcingProvider data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/" element={<App data-id="element-8" />} data-id="element-7" />
          <Route path="/sourcing" element={<SourcingEventLayout data-id="element-10" />} data-id="element-9">
            <Route path="selection" element={<SupplierDiscovery data-id="element-12" />} data-id="element-11" />
            <Route path="review" element={<ReviewScreen data-id="element-14" />} data-id="element-13" />
            <Route path="dashboard" element={<EventDashboard data-id="element-16" />} data-id="element-15" />
          </Route>
        </Routes>
      </SourcingProvider>
    </BrowserRouter>;
}